import { useAutoWidgetPlugins } from './auto-widget'
import { dragHistoryWidthPlugins } from './drag-history-width'
function noop () {}
export function table2WrapPluginsFactory () {
  try {
    const pluginTasks = [
      useAutoWidgetPlugins,
      dragHistoryWidthPlugins
    ]
    let initializedPlugins = []
    // 插件注册
    const register = (vm) => {
      initializedPlugins = pluginTasks.map(task => {
        const pluginInstance = task && task(vm)
        const { name, ...pluginInstanceExportMethods } = pluginInstance
        vm[name] = pluginInstanceExportMethods
        return pluginInstance
      })
    }
    // 插件销毁
    const destroy = () => {
      initializedPlugins.forEach(plugin => {
        if (typeof plugin.destroy === 'function') {
          plugin.destroy()
        }
      })
      initializedPlugins = []
    }
    return {
      register,
      destroy
    }
  } catch (error) {
    console.error(error)
    return {
      register: noop,
      destroy: noop,
    }
  }
}



// WEBPACK FOOTER //
// ./src/public/components/query-table/table2/plugins/index.js